<template>
  <div class="left-box pb-3 ml-5">
    <div>
      <span
        class="number"
        :style="{ color: $vuetify.theme.global?.current?.colors.primary }"
      >
        {{ number }}
      </span>
      <br />
      <span class="text">
        {{ description }}
      </span>
    </div>
  </div>
</template>
<script setup lang="ts">
defineProps({
  number: String,
  description: String,
})
</script>

<style scoped>
.left-box {
  display: flex;
  align-items: center;
}

.number {
  font-size: 26px;
  font-style: normal;
  font-weight: 700;
  line-height: 32px;
}
.text {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
}
</style>
